angular
  .module('slf')
  .filter('username', function (Users) {
    return function (userId) {
      var user = Users.getById(userId);
      return user ? user.name : 'Unbekannt';
    };
  });
